import { ORDER_TABLE_COLUMN_ID_TO_CONFIG_MAP } from './orderTableColumnIdToConfigMap';

export const STICKY_LEFT_COLUMN_ID =
  ORDER_TABLE_COLUMN_ID_TO_CONFIG_MAP.orderNumber.columnId;
